import { UserIcon } from '@dhl-ui/icons'
import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiAvatar = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiAvatar: {
      defaultProps: {
        children: <UserIcon />,
      },
      styleOverrides: {
        root: {
          fontWeight: '900',
          width: spacing(4),
          height: spacing(4),
          fontSize: spacing(1.5),

          '&.MuiAvatarGroup-avatar': {
            backgroundColor: palette.dark.main,
          },
        },
      },
    },
  }) satisfies ComponentCreation
